import { Eye, FileText, Calendar, Heart, Clock } from "lucide-react";

const ICONS = { eye: Eye, "file-text": FileText, calendar: Calendar, heart: Heart, clock: Clock };

export function UrgencySignals({ signals = [] }) {
  if (!signals.length) return null;
  return (
    <div data-testid="urgency-signals" className="flex flex-col gap-2">
      {signals.map((s, i) => {
        const Icon = ICONS[s.icon] || Eye;
        return (
          <div
            key={i}
            data-testid={`urgency-signal-${s.icon}`}
            className="inline-flex items-center gap-2.5 self-start glass px-3.5 py-2 rounded-full shadow-ambient"
          >
            <span className="relative flex items-center justify-center">
              <span className="w-1.5 h-1.5 rounded-full bg-clay pulse-dot" />
            </span>
            <Icon size={14} strokeWidth={1.5} className="text-clay" />
            <span className="text-xs text-ink-soft">{s.text}</span>
          </div>
        );
      })}
    </div>
  );
}
